export default class LocalStorageQueue {
    public static limit = 20;

    public static hasItem(name: string, key: string): boolean {
        const items = JSON.parse(window.localStorage.getItem(name) || '[]');

        return items.includes(key);
    }

    public static addItem(name: string, value: string): void {
        let items = JSON.parse(window.localStorage.getItem(name) || '[]');

        if (items.length >= this.limit) {
            items = items.slice(1);
        }

        items.push(value);

        window.localStorage.setItem(name, JSON.stringify(items));
    }
}
